import { getSelector } from './get-selector';
import { Interaction } from './types';
import { normalisePagePath } from './url-parser';

// This is limited to avoid holding on to data that we don't need when the number of interactions is
// very high and consuming too much memory. It could be smaller and in a theoretical world, we only
// need to keep hold of the slowest, but opting to set to this value inline with the web-vitals npm
// package https://github.com/GoogleChrome/web-vitals/blob/21edecf75b20d09b5a977d6fa8bf243c5ee75619/src/onINP.ts#L57
const MAX_INTERACTIONS_TO_CONSIDER = 10;

let longestInteractionList: Interaction[];

export const getExtraContextByInpValue = (inpValue: number) => {
  let inpElementSelector;

  // A workaround for when some interactions don't have a valid target/selector against in a similar vein to
  // the npm package web-vitals https://github.com/GoogleChrome/web-vitals/blob/21edecf75b20d09b5a977d6fa8bf243c5ee75619/src/attribution/onINP.ts#L45
  // An interaction may not have a valid selector at this point though of which this Github issue goes in to some detail on https://github.com/GoogleChrome/web-vitals/issues/335
  const matchingInteractions = longestInteractionList.filter(
    interaction => interaction.duration === inpValue,
  );
  const interactionWithSelector = matchingInteractions.find(interaction => interaction.selector);
  if (interactionWithSelector) {
    inpElementSelector = interactionWithSelector.selector;
  } else {
    inpElementSelector = '';
  }

  return {
    inpElementSelector,
    urlPath: normalisePagePath(window.location.pathname),
  };
};

export const init = () => {
  longestInteractionList = [];

  const eventObserver = new PerformanceObserver(list => {
    list.getEntries().forEach(entry => {
      if (!(entry instanceof PerformanceEventTiming) || !entry.interactionId) {
        return;
      }

      const interaction = {
        entries: [entry],
        duration: entry.duration,
        selector: getSelector(entry?.target),
      };

      longestInteractionList.push(interaction);
      longestInteractionList.sort((a, b) => b.duration - a.duration);
      longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER);
    });
  });

  eventObserver.observe({
    type: 'event',
    buffered: true,
  });
};
